import {
  LegalClientSourcesOfIncomeFinancialSourceType,
  LegalClientSourcesOfIncomeSourceType,
} from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { FileType, Stack } from 'libs/ui';
import { FormContentFilesProps } from 'modules/onboarding/common/types';

import {
  useFormContext,
  Field,
  MAX_FILES,
} from '../../../forms/sourcesOfIncomeForm';

export interface FormContentProps extends FormContentFilesProps {}

export const FormContent = ({
  files,
  onAddFiles,
  onRemoveFile,
}: FormContentProps) => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  const isOtherIncomeSource =
    values.incomeSources?.find(
      (v) => v?.value === LegalClientSourcesOfIncomeSourceType.Other
    ) !== undefined;

  const isOtherFinancialSource =
    values.financialSources?.find(
      (v) => v?.value === LegalClientSourcesOfIncomeFinancialSourceType.Other
    ) !== undefined;

  return (
    <Stack spacing={32}>
      <Stack spacing={24} spacingMobile={16}>
        <Field.Autocomplete
          multiple
          label={t('onboarding.legalClientSourcesOfIncome.incomeSources.label')}
          name="incomeSources"
          optionLabelKey="label"
          options={Object.values(LegalClientSourcesOfIncomeSourceType).map(
            (v) => ({
              label: t(
                `onboarding.legalClientSourcesOfIncome.incomeSources.types.${v}`
              ),
              value: v,
            })
          )}
          optionValueKey="value"
          placeholder={t(
            'onboarding.legalClientSourcesOfIncome.incomeSources.placeholder'
          )}
          variant="select"
        />

        {isOtherIncomeSource && (
          <Field.Text
            label={t(
              'onboarding.legalClientSourcesOfIncome.otherIncomeSource.label'
            )}
            name="otherIncomeSource"
            placeholder={t(
              'onboarding.legalClientSourcesOfIncome.otherIncomeSource.placeholder'
            )}
          />
        )}

        <Field.Autocomplete
          multiple
          label={t(
            'onboarding.legalClientSourcesOfIncome.financialSources.label'
          )}
          name="financialSources"
          optionLabelKey="label"
          options={Object.values(
            LegalClientSourcesOfIncomeFinancialSourceType
          ).map((v) => ({
            label: t(
              `onboarding.legalClientSourcesOfIncome.financialSources.types.${v}`
            ),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t(
            'onboarding.legalClientSourcesOfIncome.financialSources.placeholder'
          )}
          variant="select"
        />

        {isOtherFinancialSource && (
          <Field.Text
            label={t(
              'onboarding.legalClientSourcesOfIncome.otherFinancialSource.label'
            )}
            name="otherFinancialSource"
            placeholder={t(
              'onboarding.legalClientSourcesOfIncome.otherFinancialSource.placeholder'
            )}
          />
        )}
      </Stack>

      <Field.FilesUpload
        files={files}
        fileTypes={[FileType.pdf]}
        maxFiles={MAX_FILES}
        name="fileIds"
        title={t('onboarding.legalClientSourcesOfIncome.documentTitle')}
        onAddFiles={(f) => onAddFiles?.(f)}
        onRemoveFile={onRemoveFile}
      />
    </Stack>
  );
};
